import { compose, createStore } from 'redux';

import rootReducer from 'core/reducers/root';
import { currentMode } from 'core/util/Mode';
import middlewareDev from './middleware.dev';
import middlewareProd from './middleware.prod';
import ServiceRegistry from "../util/ServiceRegistry";
import ILocalCacheService from "../service/cache/ILocalCacheService";
import initialState from "../reducers/initialState";

/**
 * @overview Initializes the redux store.
 * @author jesposito
 */

declare var window: any;

// Compose with redux dev tools if in development mode and they are present
const composeEnhancers = (currentMode.isDev() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

// Get the initial state form local storage if its present
const state = ServiceRegistry.get(ILocalCacheService).get("store", initialState);

export default function configureStore(initialState?) {
	return createStore(
		rootReducer,
		initialState,
		composeEnhancers(currentMode.isDev() ? middlewareDev : middlewareProd) // Apply middleware based on env
	);
}



// WEBPACK FOOTER //
// ./src/core/store/configureStore.ts